module.exports = __webpack_public_path__ + "static/media/best_sale.25f7b662.png";